import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './Button';
import { Shield, Lock, Globe, Check, Zap, Sparkles } from 'lucide-react';
const CHECKOUT_URL = 'https://spanish-teacher-ready.impultienda.ar/checkout';
const comboIncludes = ['120 ready-to-teach Spanish lessons', 'Organized progressively for Spanish 1 and Spanish 2', '40+ weeks of fresh, non-repeating content', 'Every lesson completely structured', 'Learning objectives, vocabulary, grammar, activities and assessments included', 'Bonus 1 — Spanish Grammar Made Simple', 'Bonus 2 — 100 Conversation Activities', 'Bonus 3 — Assessment and Quiz Bank', 'Bonus 4 — 30 Culture Lessons', 'Bonus 5 — 30 Emergency Lessons', '7-day money-back guarantee', 'Immediate access', 'PDF format — ready to use'];
export function PricingSection() {
  return <section id="pricing" className="py-20 px-4 bg-black relative" data-id="element-193" data-mp="2wjohl98to1i">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-lg h-[500px] bg-gold/20 blur-[120px] rounded-full pointer-events-none" data-id="element-194" data-mp="7utkfy2skso6"></div>

      <div className="max-w-3xl mx-auto relative z-10" data-id="element-195" data-mp="1hpg4sdsizm6n">
        <div className="text-center mb-10" data-id="element-196" data-mp="1hon2pq4ihkuu">
          <h2 className="text-3xl md:text-5xl font-serif font-bold mb-3" data-id="element-197" data-mp="1cqbxjsp5vyiy">
            Your Complete Offer Today
          </h2>
          <p className="text-gold-light text-sm md:text-base" data-id="element-198" data-mp="17t3b3fwzd8bw">
            The complete teaching system + 5 strategic bonuses — ready for your next class.
          </p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-navy-card border-2 border-gold rounded-3xl p-1 relative shadow-[0_0_50px_rgba(212,175,55,0.2)]" data-id="element-199" data-mp="20g68g4px7d0k">
          <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-gold-gradient text-black font-bold px-5 py-1.5 rounded-full shadow-lg uppercase tracking-wider text-xs flex items-center gap-1.5 whitespace-nowrap" data-id="element-200" data-mp="k1xxz8ifcu5a">
            <Sparkles size={14} data-id="element-201" data-mp="hhi41d8rmwj1" /> Complete Package
          </div>

          <div className="bg-black rounded-[1.3rem] p-6 md:p-10 text-center" data-id="element-202" data-mp="mgundo0fhlgv">
            <h3 className="text-2xl md:text-3xl font-serif font-bold text-gold-gradient mb-3" data-id="element-203" data-mp="merzpamr04fb">
              Spanish Teacher Ready™
            </h3>
            <p className="text-base text-gray-300 mb-6" data-id="element-204" data-mp="chvq11l45c96">
              Everything you need to teach Spanish 1 and Spanish 2 with confidence.
            </p>

            <ul className="text-left max-w-md mx-auto space-y-2 mb-6 bg-gold/5 border border-gold/20 rounded-xl p-4" data-id="element-205" data-mp="3uuti6mbnz0ss">
              {comboIncludes.map((item, i) => <li key={i} className="flex items-start gap-2 text-sm text-gray-200" data-id="element-206" data-mp="3l01lrlttijzl" data-mpi={i}>
                  <Check size={16} className="text-gold shrink-0 mt-0.5" data-id="element-207" data-mp="3pymj9dhoqpkc" />
                  <span data-id="element-208" data-mp="3bxa8dghdte5b">{item}</span>
                </li>)}
            </ul>

            <div className="mb-6" data-id="element-209" data-mp="3fz5hv89guxu6">
              <span className="text-lg text-gray-500 line-through block mb-1" data-id="element-210" data-mp="3fy3vi7n02ox5">
                USD 105.00
              </span>
              <div className="flex items-baseline justify-center gap-2" data-id="element-211" data-mp="2xd7f9ayabafk">
                <span className="text-2xl md:text-3xl text-white" data-id="element-212" data-mp="2sdbl03fe2xd7">TODAY ONLY:</span>
                <span className="text-4xl md:text-5xl font-bold text-gold" data-id="element-213" data-mp="36cui816nwoaq">
                  USD 27.00
                </span>
              </div>
            </div>

            <Button href={CHECKOUT_URL} target="_blank" onLinkClick={() => {
            if (typeof window !== 'undefined' && (window as any).fbq) {
              ;
              (window as any).fbq('track', 'InitiateCheckout', {
                content_name: 'Spanish Teacher Ready Complete System',
                value: 27.0,
                currency: 'USD'
              });
            }
          }} className="w-full md:w-auto text-base md:text-lg py-4 px-8 mb-5" data-id="element-214" data-mp="3g9z6q7nzcvup">
              🟡 GET THE COMPLETE TEACHING SYSTEM NOW
            </Button>

            <div className="flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs text-gray-400 mb-4" data-id="element-215" data-mp="hx1b4vgwjgj2">
              <span className="flex items-center gap-1.5" data-id="element-216" data-mp="lymki6u89coi">
                <Lock size={12} className="text-gold" data-id="element-217" data-mp="qqeekrcle0je" /> Secure payment
              </span>
              <span className="flex items-center gap-1.5" data-id="element-218" data-mp="vphi27cxbyp9">
                <Zap size={12} className="text-gold" data-id="element-219" data-mp="vozcgk4dg84o" /> Immediate access
              </span>
              <span className="flex items-center gap-1.5" data-id="element-220" data-mp="3v5xlzknu45hd">
                <Shield size={12} className="text-gold" data-id="element-221" data-mp="30jym0wz7vux" /> 7-day guarantee
              </span>
            </div>

            <div className="bg-white/5 border border-white/10 rounded-xl p-3 max-w-md mx-auto flex items-start gap-2.5 text-left" data-id="element-222" data-mp="7zdbps8cpkuk">
              <Globe className="text-gold shrink-0 mt-0.5" size={14} data-id="element-223" data-mp="d0kmm05sj05g" />
              <p className="text-[11px] text-gray-400 leading-snug" data-id="element-224" data-mp="1jfv0r79mcl76">
                Pay in your local currency. The amount adjusts automatically based on your country.
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}